window.RS = window.RS || {};
window.RS.Klaviyo = window.RS.Klaviyo || {};
class RsKlaviyoBis extends HTMLElement {
  constructor() {
    super();
    this.HIDDEN_CLASS = 'hidden';
    this.BIS_SUBMISSION_EVENT = 'klaviyo:bisSubmission';
    this.NEWLETTER_SUBMISSION_EVENT = 'klaviyo:newletterSubmission';
    this.VARIANT_CHANGED_EVENT = 'variant:changed';
    this.apiVersion = this.dataset.apiVersion || '2024-07-15';
    this.companyId = this.dataset.companyId;
    this.newsletterId = this.dataset.newsletterId;
    this.productId = this.dataset.productId;
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.handleBisSubmissionResp = this.handleBisSubmissionResp.bind(this);
    this.handleVariantChange = this.handleVariantChange.bind(this);

    if (!window.RS.Klaviyo?.bis) {
      window.RS.Klaviyo.bis = {
        bisSubmissionEventRegistered: false
      }
    }

    if (!window.RS.Klaviyo?.bis?.bisSubmissionEventRegistered) {
      document.addEventListener(this.BIS_SUBMISSION_EVENT, this.handleBisSubmissionResp);
      window.RS.Klaviyo.bis.bisSubmissionEventRegistered = true;
    }

    if (!window.RS.Klaviyo?.newletter) {
      window.RS.Klaviyo.newletter = {
        newletterSubmissionEventRegistered: false
      }
    }

    if (!window.RS.Klaviyo?.newletter?.newletterSubmissionEventRegistered) {
      document.addEventListener(this.NEWLETTER_SUBMISSION_EVENT, this.handleNewsletterSubmissionResp);
      window.RS.Klaviyo.newletter.newletterSubmissionEventRegistered = true;
    }

    document.addEventListener(this.VARIANT_CHANGED_EVENT, this.handleVariantChange);
  }
  connectedCallback() {
    this.form = this.querySelector('[data-bis-form]');
    this.submit = this.form?.querySelector('[data-bis-submit]');
    this.errorElem = this.querySelector('[data-bis-error]');
    this.successElem = this.querySelector('[data-bis-success]');
    this.formElems = this.querySelector('[data-bis-form-elems]');
    this.form?.addEventListener('submit', this.handleOnSubmit);
  }
  async handleOnSubmit(e) {
    e.preventDefault();
    const formData = new FormData(this.form);
    const variantId = formData.get('variant_id');
    const email = formData.get('email');
    const newsletterSubscribe = formData.get('subscribe_for_newsletter');
    
    if (!variantId || !this.companyId || !this.apiVersion) {
      console.log("Missing params");
    } else if (!email) {
      console.log("Email required");
    } else {
      const data = {
        email,
        variantId,
        companyId: this.companyId,
        apiVersion: this.apiVersion,
        newsletterId: this.newsletterId
      };

      // Submit the back in stock
      const resp = await this.submitBIS(data);

      // Submit the newsletter subscription
      if (this.newsletterId && newsletterSubscribe === 'on') {
        const newsletterResp = this.submitNewsletter(data);
      }
    }
  }
  async submitBIS(data) {
    const resp = {};
    if (!data) {
      resp.ok = false;
      resp.errorData = {
        message: 'Missing data'
      }
    } else {
      const body = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: data.email
                }
              }
            },
            "channels": ["EMAIL"],
          },
          relationships: { 
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${data.variantId}`
              }
            }
          }
        }
      };

      const headers = {
        revision: data.apiVersion,
        'content-type': 'application/json'
      }
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
      };
      const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${data.companyId}`;

      const payload = {
        detail: {
          target: this
        }
      };

      try {
        const response = await fetch(url,options);
        payload.detail.response = response;

        if (response?.ok) {
          payload.detail.success = true;
        } else {
          payload.detail.success = false;
        }
      } catch (error) {
        console.log("****** | RsKlaviyoBis | submitBIS | error:", error);
        payload.detail.success = false;
      }

      if (payload.detail.success) {
        resp.ok = true;
      } else {
        resp.ok = false;
        resp.errorData = {
          message: 'Error submitting Klaviyo back in stock.'
        }
      }

      const event = new CustomEvent(this.BIS_SUBMISSION_EVENT, payload);
      document.dispatchEvent(event);
    }

    return resp;
  }
  async submitNewsletter(data) {
    const resp = {};
    if (!data) {
      resp.ok = false;
      resp.errorData = {
        message: 'Missing data'
      }
    } else {
      const body = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: data.email
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: data.newsletterId
              }
            }
          }
        }
      };

      console.log("body: ", body);

      const headers = {
        revision: data.apiVersion,
        'content-type': 'application/json'
      }
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
      };
      const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${data.companyId}`;

      const payload = {
        detail: {
          target: this
        }
      };

      try {
        const response = await fetch(url,options);
        payload.detail.response = response;

        if (response?.ok) {
          payload.detail.success = true;
        } else {
          payload.detail.success = false;
        }
      } catch (error) {
        console.log("****** | RsKlaviyoBis | submitNewsletter | error:", error)
        payload.detail.success = false;
      }

      if (payload.success) {
        resp.ok = true;
      } else {
        resp.ok = false;
        resp.errorData = {
          message: 'Error submitting Klaviyo subscription.'
        }
      }

      const event = new CustomEvent(this.NEWLETTER_SUBMISSION_EVENT, payload);
      document.dispatchEvent(event);
    }

    return resp;
  }
  handleBisSubmissionResp(e) {
    const target = e?.detail?.target;
    const response = e?.detail?.response;

    if (target && response) {
      if (response?.ok) {
        target?.querySelectorAll('[data-bis-success-show]').forEach((elem) => {
          elem?.classList?.remove(target.HIDDEN_CLASS);
        });
        target?.querySelectorAll('[data-bis-success-hide]').forEach((elem) => {
          elem?.classList?.add(target.HIDDEN_CLASS);
        });
        target?.submit?.setAttribute('disabled', 'true');
      } else {
        target?.querySelectorAll('[data-bis-error-show]').forEach((elem) => {
          elem?.classList?.remove(target.HIDDEN_CLASS);
        });
        target?.querySelectorAll('[data-bis-error-hide]').forEach((elem) => {
          elem?.classList?.add(target.HIDDEN_CLASS);
        });
        target?.submit?.removeAttribute('disabled');
      }
    }
  }
  handleNewsletterSubmissionResp(e) {
    // Scope did not include success/error handling when submitting the newsletter
    // subscription. Leaving here for is required in the future.
    console.log("****** | RsKlaviyoBis | handleNewsletterSubmissionResp | e:", e)
  }
  handleVariantChange(e) {
    const { detail } = e || {};
    const { productId, variantId, targetBis, isUnavailable } = detail || {};

    if (targetBis === this?.id && productId === this.productId) {
      const variantInput = this.form?.querySelector('[name="variant_id"]');
      this.resetForm();

      if (variantInput) {
        variantInput.value = variantId;
      }
      if (isUnavailable) {
        this.classList.remove(this.HIDDEN_CLASS);
      } else {
        this.classList.add(this.HIDDEN_CLASS);
      }
    }
  }
  resetForm() {
    this?.querySelectorAll('[data-bis-success-show]').forEach((elem) => {
      elem?.classList?.add(this.HIDDEN_CLASS);
    });
    this?.querySelectorAll('[data-bis-error-show]').forEach((elem) => {
      elem?.classList?.add(this.HIDDEN_CLASS);
    });
    this.formElems?.classList.remove(this.HIDDEN_CLASS);
    this?.submit?.removeAttribute('disabled');
  }
}

customElements.define('rs-klaviyo-bis', RsKlaviyoBis);